<span id="{{Id}}">{{ displayDate | date: dateFormat : columnInfoDto?.TimeZone : columnInfoDto?.Locale }}</span>
